import { useMemo, useState, useEffect } from 'react';
import { keyBy } from 'lodash';
import axios from 'common/requester';
import { API } from 'common/constants/api-urls';
import { REPOS_AUTO_DISCOVERY_STATE_TYPE } from '@linearb/linjs-common';

const useAutoRepoDiscovery = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const dataByIntegrationId = useMemo(
    () => keyBy(data, 'sensor_authorization_id'),
    [data]
  );

  const deleteBySettingId = async id => {
    if (!id) return;
    await axios.delete(`${API.AUTO_REPO_DISCOVERY_FILTERS}/${id}`);
    fetchData();
  };

  const upsertByIntegrationId = async (
    integrationId,
    { filter, extra, state }
  ) => {
    if (!integrationId) return false;
    try {
      await axios.post(API.AUTO_REPO_DISCOVERY_FILTERS, {
        sensor_authorization_id: Number(integrationId),
        filter,
        extra,
        state
      });
      await fetchData();
    } catch (e) {}
  };

  const getSettingByIntegrationId = integrationId => {
    const setting = dataByIntegrationId[integrationId];
    const settingId = setting?.id;

    return {
      value: setting,
      isExists: !!settingId,
      isActive: setting?.state === REPOS_AUTO_DISCOVERY_STATE_TYPE.ACTIVE,
      ...(settingId && {
        delete: async () => await deleteBySettingId(settingId)
      }),
      upsert: async settingPayload =>
        await upsertByIntegrationId(integrationId, settingPayload)
    };
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(API.AUTO_REPO_DISCOVERY_FILTERS);
      if (Array.isArray(res)) {
        setData(res);
      }
    } catch (e) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return {
    isLoading,
    getSettingByIntegrationId
  };
};

export default useAutoRepoDiscovery;
